import { all } from "redux-saga/effects";
import {
  searchVehicleWithPriceSequence,
  watchBookingAsync,
} from "./bookingSaga";
import { watchMapAsync } from "./mapSaga";
import { watchVehicleAsync } from "./vehicleSaga";
import { watchAuthAsync } from "./authSaga";
import { watchCompanyAsync } from "./companySaga";
import { watchRegionAsync } from "./regionSaga";
import { watchEventAsync } from "./eventSaga";
import { watchAffiliateAsync } from "./affiliateSaga";
import { watchCreditCardAsync } from "./creditCardSaga";
import { watchSettingsAsync } from "./settings";
import { watchDocketSaga } from "./docket/docketSaga";
import { watchAsyncInvoiceRecord } from "./docket/invoiceSaga";

export function* rootSaga() {
  yield all([
    watchMapAsync(),
    watchBookingAsync(),
    searchVehicleWithPriceSequence(),
    watchVehicleAsync(),
    watchAuthAsync(),
    watchCompanyAsync(),
    watchRegionAsync(),
    watchEventAsync(),
    watchAffiliateAsync(),
    watchCreditCardAsync(),
    watchSettingsAsync(),
    watchDocketSaga(),
    watchAsyncInvoiceRecord(),
  ]);
}
